import { NativeMockBackground } from '../../widgets/NativeMockBackground';
import { InstallCard } from './components/InstallCard';

export function PwaInstallSafariIos27() {
  return (
    <NativeMockBackground>
      <InstallCard />
    </NativeMockBackground>
  );
}
